var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { APIClient, LocalStorage } from '@lean-body/src/infra';
import { FBPixelClient, GAClient, CloudFunctionClient, TagClient, LambdaFunctionClient, AdlocateClient, AdTrackClient, NtaClient, OaiqClient, } from '@lean-body/src/infra';
import { FBClient } from '@lean-body/src/infra/fb_client';
import { LINEClient } from '@lean-body/src/infra/line_client';
import { AppleClient } from '@lean-body/src/infra/apple_client';
import { Memoize } from '@lean-body/src/util';
import { AccountService } from './account';
import { ABTestService } from './ab_test';
import { AuthState, MeRepository } from './account';
import { Tracker } from './tracker';
import { AnnouncementService } from './announcement';
import { LessonService } from './lesson';
import * as routes from '../route/routes';
import { SignedCookieService } from './signed_cookie';
import { TwitterService } from './twitter';
// ドメインサービスをfactoryするクラス。外部からサービスを参照するときはこのクラス経由で参照する。
export class DomainFactory {
    constructor(config, alertPresenter) {
        Object.defineProperty(this, "config", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "apiClient", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "fbClient", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "lineClient", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "appleClient", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "tagClient", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "fbPixelClient", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "adlocateClient", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "adTrackClient", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "ntaClient", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "oaiqClient", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "gaClient", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "localStorage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "cloudFunctionClient", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "lambdaFunctionClient", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "navigate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "alertPresenter", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "tracker", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        if (config.isProdOrStg) {
            // stg or prodのみ有効な機能
            this.fbClient = new FBClient(config.fbAppId);
            this.fbPixelClient = new FBPixelClient(config.fbPixelId);
        }
        this.lineClient = new LINEClient(config);
        this.appleClient = new AppleClient();
        this.adlocateClient = new AdlocateClient(config);
        this.adTrackClient = new AdTrackClient(config);
        this.ntaClient = new NtaClient(config);
        this.oaiqClient = new OaiqClient(config);
        this.gaClient = new GAClient(config);
        this.localStorage = new LocalStorage();
        this.cloudFunctionClient = new CloudFunctionClient(config.bqCloudFunctionsEndpoint, config.bqCfAuthToken, this.localStorage);
        this.lambdaFunctionClient = new LambdaFunctionClient(config.awsLambdaEndpoint);
        this.config = config;
        this.apiClient = this.buildApiClient();
        this.alertPresenter = alertPresenter;
    }
    initializeNavigate(navigate) {
        this.navigate = navigate;
    }
    buildApiClient() {
        const unauthorizedCallback = () => {
            this.AuthState().setUnAuthed();
            this.localStorage.saveLoginState(false);
            this.navigate(routes.SIGNIN.compile());
        };
        const maintenanceCallback = () => {
            this.navigate(routes.MAINTENANCE.compile());
        };
        return new APIClient(this.config, this.localStorage, unauthorizedCallback, maintenanceCallback);
    }
    // ユーザーIDの必要なClientを初期化
    buildWithUserID(userID) {
        this.tagClient = new TagClient(this.config, userID);
        this.initializeTracker(userID, this.tagClient);
    }
    LessonService() {
        return new LessonService(this.apiClient, this.Tracker(), this.MeRepo(), this.config);
    }
    AccountService() {
        return new AccountService(this.AuthState(), this.apiClient, this.fbClient, this.lineClient, this.appleClient, this.localStorage, this.navigate, this.config);
    }
    ABTestService() {
        return new ABTestService(this.tagClient, this.localStorage);
    }
    Tracker() {
        return this.tracker;
    }
    AuthState() {
        return new AuthState();
    }
    MeRepo() {
        return new MeRepository(this.apiClient, this.config);
    }
    AnnouncementService() {
        return new AnnouncementService(this.apiClient, this.config);
    }
    SignedCookieService() {
        return new SignedCookieService(this.apiClient);
    }
    TwitterService() {
        return new TwitterService(this.apiClient, this.alertPresenter, this.localStorage, this.Tracker(), this.navigate);
    }
    initializeTracker(userId, tagClient) {
        this.tracker = new Tracker(this.localStorage, this.fbPixelClient, this.cloudFunctionClient, this.gaClient, this.lambdaFunctionClient, this.oaiqClient, this.config);
        this.Tracker().setUserID(userId);
        this.Tracker().setTagClient(tagClient);
    }
}
__decorate([
    Memoize
], DomainFactory.prototype, "LessonService", null);
__decorate([
    Memoize
], DomainFactory.prototype, "AccountService", null);
__decorate([
    Memoize
], DomainFactory.prototype, "ABTestService", null);
__decorate([
    Memoize
], DomainFactory.prototype, "Tracker", null);
__decorate([
    Memoize
], DomainFactory.prototype, "AuthState", null);
__decorate([
    Memoize
], DomainFactory.prototype, "MeRepo", null);
__decorate([
    Memoize
], DomainFactory.prototype, "AnnouncementService", null);
__decorate([
    Memoize
], DomainFactory.prototype, "SignedCookieService", null);
__decorate([
    Memoize
], DomainFactory.prototype, "TwitterService", null);
